var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('PageHeader',{scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('b-icon-clipboard-plus'),_vm._v(" Dashboard ")]},proxy:true}])}),_c('b-container',{attrs:{"fluid":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }